import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.406 3.342C7.40548 2.48014 8.68024 2.00414 10 2C12.69 2 14.923 4 15.166 6.579C16.758 6.804 18 8.137 18 9.773C18 11.569 16.502 13 14.687 13H12C11.8674 13 11.7402 12.9473 11.6464 12.8536C11.5527 12.7598 11.5 12.6326 11.5 12.5C11.5 12.3674 11.5527 12.2402 11.6464 12.1464C11.7402 12.0527 11.8674 12 12 12H14.688C15.979 12 17 10.988 17 9.773C17 8.557 15.98 7.545 14.687 7.545H14.187V7.045C14.188 4.825 12.328 3 10 3C8.91988 3.00431 7.87684 3.39443 7.059 4.1C6.302 4.752 5.906 5.538 5.906 6.155V6.603L5.461 6.652C4.064 6.805 3 7.952 3 9.318C3 10.785 4.23 12 5.781 12H8C8.13261 12 8.25979 12.0527 8.35355 12.1464C8.44732 12.2402 8.5 12.3674 8.5 12.5C8.5 12.6326 8.44732 12.7598 8.35355 12.8536C8.25979 12.9473 8.13261 13 8 13H5.781C3.708 13 2 11.366 2 9.318C2 7.555 3.266 6.095 4.942 5.725C5.085 4.862 5.64 4.002 6.406 3.342Z",
      fill: "white",
      stroke: "white",
      "stroke-width": "0.5"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.64602 6.14592C9.69247 6.09935 9.74764 6.06241 9.80839 6.0372C9.86913 6.012 9.93425 5.99902 10 5.99902C10.0658 5.99902 10.1309 6.012 10.1917 6.0372C10.2524 6.06241 10.3076 6.09935 10.354 6.14592L13.354 9.14592C13.4479 9.2398 13.5007 9.36714 13.5007 9.49992C13.5007 9.63269 13.4479 9.76003 13.354 9.85392C13.2601 9.9478 13.1328 10.0005 13 10.0005C12.8672 10.0005 12.7399 9.9478 12.646 9.85392L10.5 7.70692V16.4999C10.5 16.6325 10.4473 16.7597 10.3536 16.8535C10.2598 16.9472 10.1326 16.9999 10 16.9999C9.86741 16.9999 9.74024 16.9472 9.64647 16.8535C9.5527 16.7597 9.50002 16.6325 9.50002 16.4999V7.70692L7.35402 9.85392C7.26013 9.9478 7.1328 10.0005 7.00002 10.0005C6.86725 10.0005 6.73991 9.9478 6.64602 9.85392C6.55213 9.76003 6.49939 9.63269 6.49939 9.49992C6.49939 9.36714 6.55213 9.2398 6.64602 9.14592L9.64602 6.14592Z",
      fill: "white",
      stroke: "white",
      "stroke-width": "0.5"
    }, null, -1)
  ]))]))
}
export default { render: render }